module.exports = __webpack_public_path__ + "static/media/bg-banner-employers.5b76dcb5.jpg";